// extracted by mini-css-extract-plugin
export default {"root":"Card_root__hz3aS","head":"Card_head__RaDip","title":"Card_title__A6GVy","actions":"Card_actions__Begb1"};